export default __webpack_public_path__ + "static/media/team-5.d16f1d7e.png";